import {Cureus} from '../Cureus';

Cureus.Judgeship = {};
//= require_tree ./Judgeship